import React from 'react';
import { colors } from '../../Colors';

function Footer() {
  return (
    <footer style={{
      background: colors.gradients.primary,
      color: colors.neutral.white,
      padding: '40px 20px',
      marginTop: '60px',
      borderTop: `3px solid ${colors.primary.dark}`
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: '60px',
          flexWrap: 'wrap',
          width: '100%'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            textAlign: 'center',
            flex: '1',
            minWidth: '200px'
          }}>
            <div style={{
              fontSize: '1.1rem',
              fontWeight: '600',
              marginBottom: '5px'
            }}>
              📍 Adresse
            </div>
            <div style={{
              fontSize: '0.95rem',
              color: colors.neutral.lightGray,
              lineHeight: '1.6'
            }}>
              Har Sinay 8<br />
              Ohr Akiva, Israel
            </div>
          </div>
          
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            textAlign: 'center',
            flex: '1',
            minWidth: '200px'
          }}>
            <div style={{
              fontSize: '1.1rem',
              fontWeight: '600',
              marginBottom: '5px'
            }}>
              📞 Téléphone
            </div>
            <div style={{
              fontSize: '0.95rem',
              color: colors.neutral.lightGray
            }}>
              +972 586 590 130
            </div>
          </div>
        </div>
        
        <div style={{
          marginTop: '10px',
          paddingTop: '20px',
          borderTop: `1px solid rgba(255, 255, 255, 0.2)`,
          fontSize: '0.85rem',
          color: colors.neutral.lightGray,
          textAlign: 'center',
          width: '100%'
        }}>
          © {new Date().getFullYear()} Torah IA. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}

export default Footer;

